import { useEffect, useState } from "react"
import { FieldType, FieldValue, FormField, O, Option, option } from "../../../../../features/ui"
import { TableName } from "../../../../../tables"
import { useDataTypesHooks } from "../../../../../features/data-types"
import { useCustomerLoaders } from "../../../loaders/customerLoaders"
import { addressHelpers } from "../../../../../features/address"
import { customerHelpers } from "../../../hooks/customerHooks"

type Props = {
    defaultValue?: string
    value?: string
    disabled?: boolean
    showAddress?: boolean
    narrow?: boolean
    active?: boolean
    onChange?: (value?: FieldValue) => void
    onCreateNew?: () => void
}

export const CustomerField = (props: Props): FormField => {
    const { defaultValue, value, disabled, showAddress, narrow, active, onChange, onCreateNew } = props

    const [stateValue, setStateValue] = useState<O<string>>(value)
    const [options, setOptions] = useState<Option[]>([])

    const { describeAddress } = addressHelpers
    const { getDeliveryAddress } = customerHelpers
    const { formatIdentifier } = useDataTypesHooks()

    const customerLoaders = useCustomerLoaders()

    const loadOptions = async () => {
        const { loadAllCustomers } = customerLoaders()
        const customers = await loadAllCustomers(active)
        const newOptions = customers
            .filter(customer => !customer.archived || customer.id === (value || defaultValue))
            .map(customer => {
                const address = getDeliveryAddress(customer)
                const infoLabel = showAddress && address ? describeAddress(address, false) : formatIdentifier(customer.identifier)
                return option(customer.id, `${customer.name} (${infoLabel})`)
            })
        setOptions(newOptions)
    }

    useEffect(() => {
        loadOptions()
    }, [])

    useEffect(() => {
        if (value && !options.map(option => option.value).includes(value)) {
            loadOptions().then(() => setStateValue(value))
        } else {
            setStateValue(value)
        }
    }, [value])

    return {
        name: 'customerId',
        type: FieldType.TABLE,
        table: TableName.CUSTOMERS,
        label: 'Cliente',
        defaultValue,
        value: stateValue,
        options,
        disabled,
        placeholder: 'Buscar por nombre o DNI',
        narrow,
        onChange,
        onCreateNew
    }
}
